//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SessionTerminated",
  methods: {
    triggerReload() {
      window.location.reload();
    }
  }
});